const WORKER_TYPE_FIELD = 'worker_type';
const WORKER_ORTHOTRAC = 'orthotrac';
const WORKER_PRACTICEWORKS = 'practiceworks';
const WORKER_WINOMS = 'winoms';
const WORKER_SOFTDENT = 'softdent';
const WORKER_DENTRIX = 'dentrix';
const WORKER_EAGLESOFT = 'eaglesoft';
const WORKER_OPENDENTAL = 'open dental';
const WORKER_CURVEDENTAL = 'curve dental';
const WORKER_QSI = 'qsi';
const WORKER_DENTICON = 'denticon';
const WORKER_KOLLA = 'kolla';
const WORKER_CLIENT = 'client';
const CAN_START_SYNC = [WORKER_DENTICON, WORKER_QSI, WORKER_CURVEDENTAL, WORKER_KOLLA];
const PMS_PASSWORD_NOT_REQUIRED = [WORKER_KOLLA, WORKER_CLIENT];

module.exports = {
  WORKER_TYPE_FIELD,
  WORKER_ORTHOTRAC,
  WORKER_PRACTICEWORKS,
  WORKER_WINOMS,
  WORKER_SOFTDENT,
  WORKER_DENTRIX,
  WORKER_EAGLESOFT,
  WORKER_OPENDENTAL,
  WORKER_CURVEDENTAL,
  WORKER_QSI,
  WORKER_DENTICON ,
  WORKER_KOLLA,
  WORKER_CLIENT,
  CAN_START_SYNC,
  PMS_PASSWORD_NOT_REQUIRED
};
